import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '岗位名称',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-cascader',
        componentName: '下拉选择',
        fieldKey: 'accessIds',
        fieldName: '菜单权限',
        placeholder: '',
        value: [],
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          props: {
            label: 'name', children: 'children', value: 'id', multiple: true
          },
          collapseTags: true,
          isDisabled: false,
          multiple: true,
          clearable: true,
          url: 'access/tree',
          filterable: true,
          selectType: 2
        }
      }
    ]
  }

]
